<template>
    <div class="flex mb-3">
        <Calendar v-model="datesRange" selectionMode="range" :manualInput="false" dateFormat="yy.mm.dd" class="mr-2"/>
        <Button label="Загрузить" @click="loadLazyData" severity="info"/>
    </div>

    <DataTable v-if="users" :value="users" lazy paginator :rows="20" v-model:filters="filters" ref="dt" dataKey="id" stripedRows
        :totalRecords="totalRecords" :loading="loading" @page="onPage($event)" @sort="onSort($event)"
        @filter="onFilter($event)" filterDisplay="menu" :globalFilterFields="[
            'sender_id', 'merchant_id', '_id', 'status', 'sender_bank_code', 'payment_system', 'currencies', 'paid', 'date_created'
        ]" v-model:selection="selectedCustomers" :selectAll="selectAll" @select-all-change="onSelectAllChange"
        @row-select="onRowSelect" @row-unselect="onRowUnselect" 
        :rowsPerPageOptions="[5, 10, 20, 50, 100]">

        <Column field="user_name" header="Пользователь">
            <template #body="{ data }">
                <span class="text-sm flex flex-row">
                    <span class="flex" v-if='data.user_name'>{{getShort(data.user_name)}}</span>
                    <span class="flex pi pi-external-link ml-2 text-500 text-xs cursor-pointer mr-2" @click='detail_page(data.user_id, "user")'></span>
                    <span class="flex pi pi-external-link ml-2 text-blue-500 text-xs cursor-pointer mr-2" @click='detail_page(data.user_id, "transfer")'></span>
                    <span v-if="data.telegram" class="flex pi pi-telegram ml-2 text-xs cursor-pointer text-blue-600 mr-2" @click='go_to_telegram(data.telegram)'></span>
                    <span v-if="data.phone" class="flex pi pi-whatsapp ml-2 text-xs cursor-pointer text-green-600" @click='go_to_wa(data.phone)'></span>
                    <span v-if="data.sendpulse" class="flex pi pi-comments ml-2 text-xs cursor-pointer text-blue-600" @click='go_to_sp(data.sendpulse)'></span>
                </span>
            </template>
        </Column>

        <Column field="transfers" header="Переводы">
            <template #body="{ data }">
                <span class="flex flex-row " v-if="data.transfers">
                    <div v-for="amount,k of data.dates" class="flex-1">
                        <div v-if="amount>0" class="bg-primary border-round-xl" v-tooltip.top="`${k} - ${get_format_amount(amount, 'usd')}`" style="width:10px;height:10px;"></div>
                        <div v-else class="surface-100 border-round-xl" v-tooltip.top="k" style="width:10px;height:10px;"></div>
                    </div>
                </span>
            </template>
        </Column>

        <template #footer>
            <span class="text-sm">
                Всего {{ totalRecords }} записей.    
            </span>
        </template>

    </DataTable>
    <Skeleton height="2rem" v-else />

</template>

<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'

export default {
    name: 'UsersScore',
    data() {
        return {
            users: null,
            totalRecords: 0,
            load: false,
            datesRange: null,
            dateStart: null,
            dateEnd: null,
        }
    },
    watch: {
        datesRange(val){
            if(val){
                this.dateStart = val[0]
                this.dateEnd = val[1]
            }
        }
    },
    methods: {
        getShort(name){
            if(name.length>20){
                return name.substring(0, 10) + '...'
            } else {
                return name
            }
        },  
        get_column(val) {
            for(const [k,v] of Object.entries(this.selectedColumns)){
                if(v.field == val && v.header == val)return true
            }
        },
        get_short_id(value){
            return this.helper.get_short_id(value)
        },
        copy(text){
            this.helper.copy_clipboard(text)
            this.$toast.add({ severity: 'info', summary: 'Скопировано', detail: text, life: 1000 })
        },
        formatDate(value) {
            return this.helper.format_date(value)
        },
        detail_page(id, page) {
            let link = null
            switch(page){
                case 'user':
                    link = `/admin/user/${id}`
                    break
                case 'transfer':
                    link = `/admin/transfers/?user_id=${id}`
                    break
                default:
                    return
            }
            window.open(link, '_blank')
        },
        go_to_telegram(telegram){
            window.open('https://t.me/'+telegram, '_blank');
        },
        go_to_wa(phone){
            window.open('https://wa.me/'+phone, '_blank');
        },
        go_to_sp(id){
            if(!id) return
            window.open(`https://login.sendpulse.com/chatbots/chats?contact_id=${id}&channel=telegram`, '_blank')
            return
        },
        onToggle: function (e) {
            if(e.length>0){
                this.selectedColumns = e
            } else {
                this.selectedColumns = []
            }
        },
        onPage(event) {
            this.lazyParams = event
            this.loadLazyData()
        },
        onSort(event) {
            this.lazyParams = event
            this.loadLazyData()
        },
        onFilter() {
            this.lazyParams.filters = this.filters
            this.loadLazyData()
        },
        onRowSelect() {
            this.selectAll = this.selectedCustomers.length === this.totalRecords
        },
        get_format_amount(value, currency) {
            return this.helper.format_amount(value, currency)
        },
        setDatesObject(dateStart, dateEnd){
            let datesKeys = this.helper.get_dates_range(dateStart, dateEnd)
            let datesObject = {}
            for(const d of datesKeys){
                datesObject[d] = 0
            }
            return datesObject
        },
        async loadLazyData() {
            this.load = true
            window.scrollTo({ top: 0, behavior: 'smooth' })
            let frmtDateStart = new Date(this.dateStart)
            let frmtDateEnd = new Date(this.dateEnd)
            let resDateStart = frmtDateStart.getFullYear() + '.' + (frmtDateStart.getMonth() + 1) + '.' + frmtDateStart.getDate()
            let resDateEnd = frmtDateEnd.getFullYear() + '.' + (frmtDateEnd.getMonth() + 1) + '.' + frmtDateEnd.getDate()
            let users = await this.connect.users_score(
                this.lazyParams.rows, 
                this.lazyParams.first,
                this.lazyParams.filters,
                {_id: -1},
                resDateStart,
                resDateEnd
            ).then(res => res)
            if (users.result) {
                this.users = []
                this.totalRecords = users.total
                if(users.data.length>0){
                    for(const u of users.data){
                        let datesObject = this.setDatesObject(this.dateStart, this.dateEnd)
                        u.dates = datesObject
                        if(u.transfers.length>0){
                            for(const t of u.transfers){
                                if(t.created && t.amount){
                                    let date = new Date(t.created)
                                    let formarDate = date.getFullYear() + '/' + (date.getMonth() + 1) + '/' + date.getDate()
                                    if(u.dates[formarDate] != undefined && u.dates[formarDate] != null){
                                        u.dates[formarDate] += parseFloat(t.amount)
                                    }
                                }
                            }
                        }
                        this.users.push(u)
                    }
                }
            }else {
                this.$toast.add({ severity: 'error', summary: 'Ошибка', detail: users.message, life: 10000 })
            }
            this.load = false
        }
    },
    async beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
    },
    mounted() {
        let date = new Date()
        let dateEnd = new Date() 
        dateEnd.setDate(dateEnd.getMonth() - 1)
        this.dateStart = dateEnd
        this.dateEnd = date
        this.datesRange = [this.dateStart, this.dateEnd]
        this.lazyParams = {
            first: 0,
            rows: 20,
            sortField: null,
            sortOrder: null,
            filters: this.filters,
        }
        this.loadLazyData()
    }
}
</script>